import { createActionConst } from '../../../utils/action.utils';

const PROJECT_TASK_NAMESPACE = 'PROJECT_TASK';

export const STORE_PROJECT_TASK = createActionConst(PROJECT_TASK_NAMESPACE, 'STORE_PROJECT_TASK');
export const CLEAR_PROJECT_TASK = createActionConst(PROJECT_TASK_NAMESPACE, 'CLEAR_PROJECT_TASK');
